import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-charter-page',
  templateUrl: './charter-page.component.html',
  styleUrls: ['./charter-page.component.css']
})
export class CharterPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
